module.exports = __webpack_public_path__ + "static/media/9010_7011.7aae75cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/9010_7011.jpg
// module id = 121
// module chunks = 0